export const COUPON_PAGE_LOAD_READY = 'COUPON_PAGE_LOAD_READY';
export const COUPON_PAGE_LOAD_CLEAR = 'COUPON_PAGE_LOAD_CLEAR';
